import { useEffect } from "react";
import { tryTrack } from "services/tracking.service";
/**
 *  React hook for tracking
 * @param {*} datalayer
 */
export function useTracking(datalayer) {
  return {
    track: event => {
      tryTrack(event, datalayer);
    }
  };
}
export function useTrack(event, datalayer, depsArray = []) {
  const { track } = useTracking(datalayer);
  useEffect(() => {
    track(event);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...depsArray]);
}
